// Template for History, Geography, Commerce, etc.
import React from 'react';
import ContentPageLayout from '../components/ContentPageLayout';

function Terms() {
  return (
    <ContentPageLayout 
      title="[Subject Name]" 
      subtitle="[Subject description]"
      showBackButton
    >
      <div className="alert alert-info">
        <i className="fas fa-book me-2"></i>
        <strong>Study Materials:</strong> Resources, past questions, and notes available.
      </div>
      {/* Add EduCoin download system like in Math.jsx */}
    </ContentPageLayout>
  );
}

export default Terms;